export * from './privacy.component';
